import { gate } from 'hub-http/gates';
import { useGetIsUngated } from './useGetIsUngated';
export const useIsUngatedForDisplayOptimizedFormControl = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(gate('CRM:Properties:FormControlDisplayOptimized'));
};